module.exports = __webpack_public_path__ + "static/media/orion-nebula.18b4fa9d.png";